import React, { useEffect, useRef, useState } from "react";
import ViewHeader from "../Components/Common/ViewHeader/ViewHeader";
import TextInput from "../Components/Common/FormElements/TextInput/TextInput";
import DownloadButton from "../Components/Common/ListHeaderButtons/DownloadButton";
import DeleteButton from "../Components/Common/ListHeaderButtons/DeleteButton";
import FacturesList from "../Components/Factures/FacturesList/FacturesList";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";
import { useDispatch, useSelector } from "react-redux";
import { deleteInvoices, getInvoices } from "../REDUX/actions/invoices";
import DeleteInvoicesModal from "../Components/Factures/Modal/DeleteInvoicesModal";
import {
  closeCenteredModal,
  openCenteredModal,
} from "../REDUX/actions/centeredModal";
import { areFilesInList, handleDownload } from "../Utils/fileUtils";
import useOnScreen from "../hooks/useOnScreen";
import RightModal from "../Components/Modals/RightModal/RightModal";
import { useTranslation } from "react-i18next";
import Button from "../Components/Common/FormElements/Button/Button";
import AccountantInvoice from "../Components/Commandes/AccountantInvoice";
import FiltersContainer from "../Components/Common/Calendar/FiltersContainer/FiltersContainer";
import FactureFilters from "../Components/Factures/FacturesList/FeatureFilters";

const FacturesView = () => {
  const controllerRef = useRef(null);
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const [searchInput, setSearchInput] = useState();
  const [checkedInvoices, setCheckedInvoices] = useState([]);
  const { measureRef, isIntersecting } = useOnScreen();
  const [showFitlers, setShowFilters] = useState(false);

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const canDelete = user?.attributes?.userRole === 1;

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    controllerRef.current?.abort();
    controllerRef.current = new AbortController();
    dispatch({ type: "INVOICES_RESET" });
    setPage(1);
    dispatch(
      getInvoices(
        { searchInput, ...filters, page: 1 },
        controllerRef.current.signal,
      ),
    );
  };

  const clearSearch = () => {
    controllerRef.current?.abort();
    controllerRef.current = new AbortController();
    dispatch({ type: "INVOICES_RESET" });
    setSearchInput("");
    setPage(1);
    dispatch(
      getInvoices(
        { searchInput: "", ...filters, page: 1 },
        controllerRef.current.signal,
      ),
    );
  };

  const handleDeleteMany = () => {
    dispatch(
      deleteInvoices({ toDeleteInvoices: checkedInvoices, searchInput }),
    );
    setCheckedInvoices([]);
    dispatch(closeCenteredModal());
  };
  const openDeleteModal = (action, message) => {
    dispatch(
      openCenteredModal(
        <DeleteInvoicesModal handleDelete={action} message={message} />,
      ),
    );
  };

  useEffect(() => {
    if (isIntersecting) {
      controllerRef.current?.abort();
      controllerRef.current = new AbortController();
      dispatch(
        getInvoices(
          { searchInput, ...filters, page },
          controllerRef.current.signal,
        ),
      );
      setPage((prev) => prev + 1);
    }
  }, [dispatch, isIntersecting]);

  useEffect(() => {
    return () => {
      controllerRef.current?.abort();
      dispatch({ type: "INVOICES_RESET" });
    };
  }, [dispatch]);

  return (
    <ViewScroller>
      <div className="flex-1 d-flex flex-column">
        <form onSubmit={handleSearch}>
          <ViewHeader title={t("Invoices")} className="facturesViewHeader">
            <div className="max-w-350px w-100 ms-auto me-3">
              <TextInput
                withSearchBtn
                placeholder={t("Search")}
                value={searchInput}
                callback={handleSearchChange}
                onSearchBtnClick={handleSearch}
                searchButtonType="submit"
                clearSearch={clearSearch}
              />
            </div>
            <div className="listHeaderButtons d-flex">
              {user?.attributes?.userRole === 1 && (
                <>
                  <Button
                    Icon={() => <i className="bi bi-funnel fa-lg " />}
                    onClick={() => setShowFilters(!showFitlers)}
                    variant={showFitlers && "outline"}
                    className="me-2"
                  >
                    {t("Filters")}
                  </Button>
                  <Button
                    disabled={!checkedInvoices?.length > 0}
                    onClick={() =>
                      dispatch(
                        openCenteredModal(
                          <AccountantInvoice
                            combinedInvoices={checkedInvoices}
                          />,
                        ),
                      )
                    }
                    className="me-2 transition-none"
                  >
                    {t("Export invoices")}
                  </Button>
                </>
              )}

              <DownloadButton
                disabled={!areFilesInList(checkedInvoices, "uploads")}
                callback={() => handleDownload(checkedInvoices)}
              />
              {canDelete && (
                <DeleteButton
                  callback={() =>
                    openDeleteModal(
                      handleDeleteMany,
                      t("Are you sure you want to delete these invoices?"),
                    )
                  }
                  disabled={checkedInvoices.length <= 0}
                />
              )}
            </div>
          </ViewHeader>
        </form>
        {showFitlers && (
          <FiltersContainer showFitlers={showFitlers} className="mb-4 mt-3">
            <FactureFilters
              handleChange={handleChange}
              handleSearch={handleSearch}
            />
          </FiltersContainer>
        )}
        <FacturesList
          measureRef={measureRef}
          searchInput={searchInput}
          checkedInvoices={checkedInvoices}
          setCheckedInvoices={setCheckedInvoices}
          openDeleteModal={openDeleteModal}
        />
        <RightModal width={70} className="pb-4" />
      </div>
    </ViewScroller>
  );
};

export default FacturesView;
